// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

import graph from 'app/lib/graph';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      password: null
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    if (this.props.confirmation) {
      return this.setState({ modal: true });
    }
    this.props.onClick();
  };

  handleConfirmation = async () => {
    const user = this.props.user;
    const userId = (user && user.get && user.get('_id')) || user.id;

    const res = await graph(
      'mutation resetPwd ($id: ID) { resetPassword(id: $id) }',
      {
        id: userId
      }
    );

    if (res.data.resetPassword) {
      this.setState({ password: res.data.resetPassword });
    } else {
      // TODO: Handle failed request..
    }
  };

  renderTriggerButton() {
    return (
      <Button
        flat
        secondary
        tabIndex={-1}
        label={this.props.i18n('Reset password')}
        onClick={this.handleClick}
        style={{ float: 'left' }}
      />
    );
  }

  render() {
    if (this.props.confirmation) {
      const actions = this.state.password
        ? [
            <Button
              key="close"
              primary
              autoFocus
              label={this.props.i18n('Close')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />
          ]
        : [
            <Button
              key="cancel"
              secondary
              flat
              label={this.props.i18n('Cancel')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />,
            <Button
              key="submit"
              primary
              autoFocus
              label={this.props.i18n('Confirm')}
              onClick={this.handleConfirmation}
              style={{ marginLeft: '12px' }}
            />
          ];

      return (
        <div>
          {this.state.modal ? (
            <Dialog
              open
              fullWidth
              fullScreen={this.props.fullScreen}
              onClose={this.handleClose}
              className="dialog-common"
            >
              <DialogTitle>{this.props.i18n('Reset password')}</DialogTitle>
              <DialogContent>
                {this.state.password ? (
                  <div>
                    Adgangskode: <strong>{this.state.password}</strong>
                    <br />
                    <br />
                    Bemærk koden vises kun denne ene gang.
                  </div>
                ) : (
                  'Efter bekræftelse nulstilles brugens adgangskode, og den nye kode vises her på skærmen.'
                )}
              </DialogContent>
              <DialogActions>{actions}</DialogActions>
            </Dialog>
          ) : null}
          {this.renderTriggerButton()}
        </div>
      );
    }

    return this.renderTriggerButton();
  }
}

const ResetPasswordI18n = i18n(ResetPassword);

function ResetPasswordWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <ResetPasswordI18n {...props} fullScreen={fullScreen} />;
}

export default ResetPasswordWithMobileDialog;